export const setTags = (tags) => {
    return tags.map(tag => tag.name).join(' | ');
}